import { createFileRoute } from '@tanstack/react-router'
import { SuratTemplateManager } from '../../../../components/SuratTemplateManager'

export const Route = createFileRoute('/desa/$slug/dashboard/template-surat')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <SuratTemplateManager desaId={desaId} />
  },
})
